import PropTypes from "prop-types";
import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import { ProductShape, ResourceTypeShape } from "../../policies/proptypes";
import productSelectors from "../../policies/selectors/products";
import resourceTypeSelectors from "../../policies/selectors/resource-types";
import withModal from "../../shared/components/withModal";
import ScopesActions from "../components/ScopesActions";
import ScopeTypeDescription from "../components/ScopeTypeDescription";
import ScopeTypesList from "../components/ScopeTypesList";

export class Scopes extends Component {
  title = "RBAC - Scopes";

  render = () => {
    const { currentResourceType, products, parentUrl } = this.props;

    return (
      <div className="l-scopes">
        <DocumentTitle title={this.title} />
        <ScopeTypesList products={products} />
        <ScopeTypeDescription resourceType={currentResourceType} />
        <div className="l-scopes__column" style={{ gridArea: "empty" }}>
          <div className="l-scopes__column-header">
            <span className="p-muted-heading u-no-margin--bottom">&nbsp;</span>
          </div>
          <div className="l-scopes__column-panel" />
        </div>
        <ScopesActions parentUrl={parentUrl} />
      </div>
    );
  };
}

Scopes.propTypes = {
  currentResourceType: ResourceTypeShape,
  products: PropTypes.arrayOf(ProductShape).isRequired,
  parentUrl: PropTypes.string.isRequired
};

Scopes.defaultProps = {
  currentResourceType: undefined
};

const mapStateToProps = state => ({
  currentResourceType: resourceTypeSelectors.getCurrent(state),
  products: productSelectors.getFiltered(state)
});

export default withModal(
  connect(
    mapStateToProps,
    null
  )(Scopes)
);
